export default __webpack_public_path__ + "static/media/type_11_1.6b7b06b3.svg";